import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Spin, Row, Col, Checkbox, Typography, Button } from 'antd';
import get from 'lodash/get';
import map from 'lodash/map';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { campaignManagement } from '../../../redux/actions/campaignAction';

const { Title } = Typography;

const BrandCriteriaDetails = (props) => {
  const { onMove, onSubmitPayload, initialValues } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [customerDetails, setCustomerDetails] = useState([]);
  const [selectedDetails, setSelectedDetails] = useState(
    initialValues ? get(initialValues, 'selectedDetails') : [2]
  );

  const fetchCustomerDetails = () => {
    setLoading(true);
    dispatch(campaignManagement('list.customer_fields'))
      .then((result) => {
        setCustomerDetails(get(result, 'data'));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onFinish = () => {
    onSubmitPayload(3, {
      selectedDetails,
      customerDetails,
    });
  };

  useEffect(() => {
    fetchCustomerDetails();
  }, []);

  return (
    <Spin spinning={loading}>
      <Row gutter={32} className="customer-detail-setting mt-60">
        <Col xl={24}>
          <Title level={4}>Customer Details</Title>
        </Col>
        <Col xl={24}>
          <Row>
            <Col xl={12}>
              <Checkbox.Group
                style={{ width: '100%' }}
                value={selectedDetails}
                onChange={(values) => {
                  setSelectedDetails(values);
                }}
              >
                <Row>
                  {map(customerDetails, (detail, index) => (
                    <Col span={8} className="mt-20" key={index}>
                      <Checkbox
                        value={get(detail, 'id')}
                        disabled={get(detail, 'name') === 'Mobile'}
                      >
                        {get(detail, 'name')}
                      </Checkbox>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row justify="space-evenly" className="mt-60">
        <Col xl={8}>
          <Button
            className="default-primary-btn"
            type="primary"
            onClick={() => onMove(2)}
            icon={<ArrowLeftOutlined />}
          >
            Back
          </Button>
        </Col>
        <Col xl={12} />
        <Col xl={4}>
          <Button
            onClick={onFinish}
            className="default-primary-btn"
            type="primary"
            block
          >
            Save & Proceed
          </Button>
        </Col>
      </Row>
    </Spin>
  );
};

export default BrandCriteriaDetails;
